import { useGiftEditorApi } from '../../gift-editor-api/Hooks/UseGiftEditorApi';
import quickEditorApiContext from '../Provider/QuickEditorApiProvider/QuickEditorApiContext';

export const useQuickEditorApi = () => useGiftEditorApi(quickEditorApiContext);
